const portraits = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_03.png",
  size: 180,
  verticalOffset: 10
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_04.png",
  size: 110,
  verticalOffset: 0
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_05.png",
  size: 200,
  verticalOffset: 5
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_06.png",
  size: 160,
  verticalOffset: 15
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_07.png",
  size: 155,
  verticalOffset: 20
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_08.png",
  size: 155,
  verticalOffset: 10
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_09.png",
  size: 160,
  verticalOffset: 5
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_01.png",
  size: 170,
  verticalOffset: 15
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Speech_Bubble_Portrait_02.png",
  size: 140,
  verticalOffset: 0
}];
function getBubbleRadius(index: number) {
  const mod = index % 4;
  const base = "50%";
  if (mod === 0) return {
    borderRadius: `${base} ${base} ${base} ${base}`,
    borderTopRightRadius: "1rem"
  };
  if (mod === 1) return {
    borderRadius: `${base} ${base} ${base} ${base}`,
    borderBottomRightRadius: "1rem"
  };
  if (mod === 2) return {
    borderRadius: `${base} ${base} ${base} ${base}`,
    borderBottomLeftRadius: "1rem"
  };
  return {
    borderRadius: `${base} ${base} ${base} ${base}`,
    borderTopLeftRadius: "1rem"
  };
}
export default function MarqueePortraitsRow1() {
  const allPortraits = [...portraits, ...portraits];
  return <section style={{
    backgroundColor: "#F5F4F2",
    width: "100%",
    overflow: "hidden",
    height: "220px",
    position: "relative",
    fontFamily: "Switzer, sans-serif",
    color: "rgb(33, 33, 31)"
  }}>
      <style>{`
        @keyframes marqueeGo {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          display: flex;
          align-items: flex-start;
          animation: marqueeGo 30s linear infinite;
          width: max-content;
        }
        .marquee-wrapper {
          mask-image: linear-gradient(to right, rgba(0,0,0,0), rgb(0,0,0) 10%, rgb(0,0,0) 90%, rgba(0,0,0,0));
          -webkit-mask-image: linear-gradient(to right, rgba(0,0,0,0), rgb(0,0,0) 10%, rgb(0,0,0) 90%, rgba(0,0,0,0));
          overflow: hidden;
          width: 100%;
          height: 220px;
          position: relative;
        }
        .portrait-bubble {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ffffff;
          overflow: hidden;
          flex-shrink: 0;
        }
      `}</style>
      <div className="marquee-wrapper">
        <div className="marquee-track">
          {allPortraits.map((portrait, index) => {
          const originalIndex = index % portraits.length;
          const radiusStyle = getBubbleRadius(originalIndex);
          return <div key={index} className="portrait-bubble" style={{
            width: `${portrait.size}px`,
            height: `${portrait.size}px`,
            marginTop: `${portrait.verticalOffset}px`,
            marginLeft: "40px",
            marginRight: "40px",
            ...radiusStyle
          }}>
                <img src={portrait.src} alt="" className="w-full h-auto" style={{
              objectFit: "cover",
              width: "100%",
              height: "100%"
            }} />
              </div>;
        })}
        </div>
      </div>
    </section>;
}